<div>
  <mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>PLANNING {{ titre }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <mat-accordion>
        <mat-expansion-panel expanded="true" class="px-8">
          <mat-expansion-panel-header
            [collapsedHeight]="'30px'"
            [expandedHeight]="'30px'"
          ></mat-expansion-panel-header>
          <div>
            <mat-form-field *ngIf="ecran == 'action'" appearance="outline">
              <mat-label>Liste Actions</mat-label>
              <mat-select
                (selectionChange)="actionChange()"
                placeholder="Liste Actions"
                name="avtActions"
                [(ngModel)]="code"
              >
                <mat-option
                  *ngFor="let action of listeActions"
                  [value]="action.avtAction_Code"
                >
                  {{ action.avtAction_Intitule }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <app-recherche
              *ngIf="showRecherche && ecran != 'action'"
              [disabled]="disabled"
              [api]="generalService.api"
              [numColonneToShow]="numColonneToShow"
              (ChampEnter)="blurChamp($event)"
              [recherche]="recherche"
              [param]="param1Recherche"
              [param2]="param2Recherche"
              name="xx"
              [placeholder]="titre"
            >
            </app-recherche>
            <mat-form-field appearance="outline">
              <mat-label>Du</mat-label>
              <input
                (dateChange)="dateChange()"
                matInput
                [matDatepicker]="dateDebut"
                placeholder="Du"
                [(ngModel)]="date_Debut"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateDebut"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateDebut></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Au</mat-label>
              <input
                (dateChange)="dateChange()"
                matInput
                [matDatepicker]="dateFin"
                placeholder="Au"
                [(ngModel)]="date_Fin"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateFin"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateFin></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="content-liste-btn p-8">
            <div *ngFor="let week of listWeek" class="div-btn">
              <button
                [disabled]="!week.enable"
                mat-raised-button
                (click)="showDetaille(week.monthName, 'timeGridWeek')"
                color="primary"
              >
                <span>{{ week.colSpan }}</span
                >&nbsp;&nbsp;<span style="font-size: 10px">{{
                  week.monthName
                }}</span>
              </button>
            </div>
          </div>
          <div class="content-liste-btn p-8">
            <div *ngFor="let month of listMonth" class="div-btn">
              <button
                [disabled]="!month.enable"
                (click)="
                  showDetaille(
                    '1/' + (month.monthId + 1) + '/' + month.year,
                    'dayGridMonth'
                  )
                "
                mat-raised-button
                color="primary"
              >
                {{ month.monthName }}
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div style="margin-top: 10px">
        <app-calendar
          #calendarComponent
          [events]="events"
          [intervale]="intervale"
          [date_Fin]="date_Fin"
          [date_Debut]="date_Debut"
          [defaultDate]="defaultDate"
          [htmlTitre]="true"
        >
        </app-calendar>
      </div>
    </mat-card-content>
  </mat-card>
</div>
